export const state = {
  categories: [],
  docCheckList: [],
  disableBtn: true,
  disableBtn2: true,
};
